module.exports = __webpack_public_path__ + "img/icn_orderdetails.c87c9250.svg";